// extracted by mini-css-extract-plugin
module.exports = {"root":"bigStatisticPanelHead_root__1vZl-","item":"bigStatisticPanelHead_item__1aCZk"};